import currency from "currency.js";
import {useCallback, useMemo} from 'react';
import SelectableCard from "@iscr/views/UIelems/SelectableCard";
import UniFieldSUI from "@iscr/xAppLib/UniForm/UniField-SUI";
import OOSBadge from "@iscr/views/evermed/OOSBadge";
import {getMedicationPriceByLevel} from "@iscr/helpers/evermed";
import UniFormMed from "@iscr/views/med/UniFormMed";
import logger from "@iscr/xAppLib/libs/logger";

const MedicationOptionsSelector = ({medication_data, options, actionBtns, ...rest }) => {
    const FIELDS = useMemo(() => [
        {
            name: 'medication',
            label: 'Medication Selection',
            type: 'object',
            validate: (v) => v.trim().length === 18,
        },
        medication_data?.has_dva_white && {
            name: 'dva_eligible',
            label: 'Are you eligible to receive concession pricing for this medication under your DVA policy?',
            type: 'bool',
        },
    ].filter(Boolean), [JSON.stringify(medication_data)]);

    const getPricingLevel = (values, opt) => {
        const {
            is_private_prescription,
            has_valid_medicare,
            has_valid_concession,
            has_valid_dva,
            has_dva_white,
        } = medication_data;

        if(is_private_prescription){
            return 'original'
        } else if (opt.prices.concession && has_valid_concession){
            return 'concession'
        } else if (opt.prices.concession && has_valid_dva && !has_dva_white){
            return 'concession'
        } else if (opt.prices.concession && has_valid_dva && has_dva_white && values.dva_eligible === true){
            return 'concession'
        } else if (opt.prices.general && has_valid_medicare){
            return 'general'
        } else {
            return 'original'
        }
    }

    const handleMedicationSelection = useCallback((uf_this, value) => {
        logger.usg_log('MedicationDrawerSelectMedication', "action", "ButtonClicked", {value})
        uf_this.handleInputChange(null, {
            name: "medication",
            value
        })
    }, []);

    const ActionSection = actionBtns

    return (
        <UniFormMed fields={FIELDS} {...rest}>
            {(values, valids, uf_this, fields) => {
                return (
                    <div className="flex flex-col items-center">
                        <div className="flex flex-col gap-3 items-center w-full">
                            {options.map((opt) => {
                                const pricingLevel = getPricingLevel(values, opt);
                                const outOfStock = opt.stock_status === 'out_of_stock';
                                const price = getMedicationPriceByLevel(pricingLevel, opt.prices);
                                const value = {
                                    ...opt,
                                    config: {
                                        charged_pricing_level: pricingLevel,
                                        charged_price: price
                                    }
                                }
                                return (
                                    <SelectableCard
                                        key={opt.productVariantType}
                                        isInvalid={valids?.medication === false}
                                        isSelected={values.medication?.id === opt.id}
                                        onSelect={() => handleMedicationSelection(uf_this, value)}
                                        isDisabled={outOfStock}
                                        className={'w-full'}
                                    >
                                        <div className={'w-full flex justify-between p-1 text-gray-800'}>
                                            <span>{opt.label}</span>
                                            <span>{outOfStock ? <OOSBadge/> : currency(price).format()}</span>
                                        </div>
                                    </SelectableCard>
                                );
                            })}
                            {fields.dva_eligible && (
                                <div className={'p-4 text-sm !items-center'}>
                                    <UniFieldSUI fl={fields.dva_eligible} {...{valids, values, uf_this}}/>
                                </div>
                            )}

                            {actionBtns && <ActionSection {...rest}/>}
                        </div>
                    </div>
                );
            }}
        </UniFormMed>
    );
}

export default MedicationOptionsSelector;
